import * as ko from 'knockout';
import { HomeComponent } from './home-component';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('homePage');
  if (node) {
    ko.applyBindings(new HomeComponent(), node);
  }
});
